module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Mastery of Life")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("About the Author")])])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Dedication")])])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Copyright Information ©")])])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Acknowledgement")])])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Introduction")])])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-i"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Chapter I: ")]), _vm._v("Thoughts and Dreams")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#thoughts-and-dreams"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-ii",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Chapter II: ")]), _vm._v("Emotions")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#emotions",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-iii",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Chapter III: ")]), _vm._v("Stress")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#stress",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-iv",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Chapter IV: ")]), _vm._v("Live in Now")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#live-in-now",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-v",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Chapter V: ")]), _vm._v("Power of Self Belief")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#power-of-self-belief",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-vi",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Chapter VI: ")]), _vm._v("Effective Communication")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#effective-communication",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-vii",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Chapter VII: ")]), _vm._v("Relationships")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#relationships",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-viii",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Chapter VIII: ")]), _vm._v("Health")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#health",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "normal"
    }
  }, [_vm._v("Conclusion")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0